module.exports = __webpack_public_path__ + "img/python_bg@2x.1afac7f9.jpg";